import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LangProvider } from "@/contexts/LangContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import SpaAtHome from "@/pages/SpaAtHome";
import Method from "@/pages/Method";
import Hospitality from "@/pages/Hospitality";
import Philosophy from "@/pages/Philosophy";
import Testimonials from "@/pages/Testimonials";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import EmailPreview from "@/pages/EmailPreview";
import SaudiLanding from "@/pages/SaudiLanding";
import ThankYou from "@/pages/ThankYou";
import Institutional from "@/pages/Institutional";
import { Toaster } from "sonner";
import { initTracking } from "@/lib/tracking";

function App() {
  useEffect(() => { initTracking(); }, []);
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/hospitality" element={<Hospitality />} />
              <Route path="/spa-at-home" element={<SpaAtHome />} />
              <Route path="/method" element={<Method />} />
              <Route path="/philosophy" element={<Philosophy />} />
              <Route path="/institutional" element={<Institutional />} />
              <Route path="/testimonials" element={<Testimonials />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/email-preview" element={<EmailPreview />} />
            <Route path="/sa" element={<SaudiLanding />} />
            <Route path="/sa/thank-you" element={<ThankYou />} />
            <Route path="/gcc" element={<SaudiLanding />} />
            <Route path="/gcc/thank-you" element={<ThankYou />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" richColors />
      </LangProvider>
    </div>
  );
}

export default App;
